module.exports = __webpack_public_path__ + "static/Product-Summary-P1.904-Indoor-d512eb1fba2b66d847042d2fa2d26236.jpg";